import { useSuspenseQuery } from '@apollo/client/react'
import { AdminAPI, getFragment, SharedAPI } from '@guestgoodie/graphql'

export function useFeatures() {
  const { data, error } = useSuspenseQuery(
    AdminAPI.integration.GET_ALL_FEATURES,
    {
      errorPolicy: 'all'
    }
  )

  if (error || !data) {
    if (error?.message !== 'not_found') throw error

    return null
  }

  return getFragment(
    SharedAPI.integration.FEATURE_FRAGMENT,
    data.getAllIntegrationFeatures
  )
}
